export const getBasicItemStyle = () => ({
  textContainer: {
    marginTop: 16,
    '& .text-title': {
      fontSize: 12,
      lineHeight: '16px',
      fontWeight: 600,
    },
    '& .text-field': {
      width: '100%',
      marginTop: 8,
    },
    '& .item-title': {
      display: 'flex',
      alignItems: 'center',
    },
  },

  buttonContainer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    height: 64,
    backgroundColor: 'white',
    display: 'flex',
    padding: '0 32px',
    boxShadow: '0px -1px 2px 0px rgba(0, 0, 0, 0.10)',
    zIndex: 5,
    '& .ms-Button': {
      width: 78,
      height: 32,
      marginTop: 16,
    },
    '& .cancel-button': {
      marginLeft: 4,
    },
  },

  imageContainer: {
    marginTop: 16,
    '& .image-title': {
      fontSize: 12,
      lineHeight: '16px',
      fontWeight: 600,
    },
    '& .item-title': {
      display: 'flex',
      alignItems: 'center',
    },
    '& .image-box': {
      width: 140,
      height: 110,
      marginTop: 8,
      position: 'relative',
      borderRadius: 6,
      overflow: 'hidden',
      boxShadow: '0px 0.3px 0.9px 0px rgba(0, 0, 0, 0.10), 0px 1.6px 3.6px 0px rgba(0, 0, 0, 0.13)',
      '& img': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
      '& .edit-button-container': {
        position: 'absolute',
        right: 8,
        bottom: 8,
        background: 'rgba(255, 255, 255, 0.83)',
        borderRadius: '50%',
        display: 'none',
        width: 32,
        height: 32,
        '&.have-delete': {
          right: 44,
        },
      },
      '&:hover .edit-button-container': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      '& .edit-image-button': {
        '&:hover': {
          background: 'transparent',
        },
      },
      '& .delete-button-container': {
        position: 'absolute',
        right: 8,
        bottom: 8,
        background: 'rgba(255, 255, 255, 0.83)',
        borderRadius: '50%',
        display: 'none',
        width: 32,
        height: 32,
      },
      '&:hover .delete-button-container': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      '& .delete-image-button': {
        '&:hover': {
          background: 'transparent',
        },
      },
    },
    '& .image-load-fail-msg': {
      marginTop: 8,
    },
  },
});
